export const annotatorProjectsMessagesEn = {
  'annotatorProjects.header.title': 'Projects',
  'annotatorProjects.summary.totalProjects.title': 'Total projects',
  'annotatorProjects.summary.refStdReview.title': 'Reference standard review',
  'annotatorProjects.summary.inProgressProjects.title': 'In progress',
  'annotatorProjects.summary.completedProjects.title': 'Completed',
  'annotatorProjects.content.table.status.ref_std_review': 'Reference standard review',
  'annotatorProjects.content.table.status.inprogress': 'In progress',
  'annotatorProjects.content.table.status.completed': 'Completed',
  'annotatorProjects.content.table.status.created': 'Created',
  'annotatorProjects.content.table.status.active': 'Active',
  'annotatorProjects.content.table.status.draft': 'Draft',
};
